export const MessageActionType = Object.freeze({
  EmailConfirmation: 0,
  SMSConfirmation: 1,
  EmailCancellation: 2,
  SMSCancellation: 3,
  EmailReminder: 4,
  SMSReminder: 5,
  EmailReschedule: 6,
  SmsReschedule: 7,
});
